module.exports = __webpack_public_path__ + "media/images/charity-f1565d8fb123e191fcd3442d346a4b42.jpg";